import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { Review } from '../../interfaces/Review/Review';
import { ReviewFilter } from '../../interfaces/Review/ReviewFilter';
import { getReviews } from '../../api/Review';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { ReviewsTable } from './ReviewsTable';
import { SearchBox } from '../../components/SearchBox/SearchBox';

export const ReviewsPage = () => {
  const [reviews, setReviews] = useState<PaginatedResponse<Review>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState<ReviewFilter>({
    search: '',
    pagination: {
      page: 0,
      pageSize: 10,
    },
  });
  const [loading, setLoading] = useState(false);

  const refreshReviews = () => {
    setLoading(true);
    getReviews(filter)
      .then((r) => setReviews(r))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshReviews();
  }, [filter]);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Box sx={{ display: 'flex', flexDirection: 'row', mb: 1.5 }}>
        <Typography variant='h5'>Değerlendirmeler</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <SearchBox
          placeholder='Değerlendirme Ara'
          initialValue={filter.search ?? ''}
          onChange={(s) =>
            setFilter({
              ...filter,
              search: s,
              pagination: { ...filter.pagination, page: 0 },
            })
          }
        />
      </Box>

      <ReviewsTable
        reviews={reviews.data}
        totalCount={reviews.totalCount}
        pagination={filter.pagination}
        onPagination={(p) => setFilter({ ...filter, pagination: p })}
      />
    </Box>
  );
};
